import React, {} from "react";
import {daysBetween, getDefaultPaymentMethod, getDetailsText, openTermDetailsPage} from "../../../helpers/helpers";
import GenericButton from "../../common/buttons/GenericButton";
import {PAYMENT_TYPE, SUBSCRIPTION_ROOT_PAGES} from "../../../constants";
import GenericItem from "../../common/items/GenericItem";
import BackButton from "../../common/buttons/BackButton";
import VdsSplashPageNewUserItem from "../vds/pages/VdsSplashNewUserItem";
import VriSplashPageNewUserItem from "../vri/pages/VriSplashPageNewUserItem";

const SplashPage = (props: {
    setPage: Function,
    setPayNow: Function,
    setRootPage: Function,
    pages: Object,
    paymentType: number,
    levelType: Object
}) => {
    const {data, pages, paymentType, levelType, setPage, setPayNow, setRootPage} = props;
    const {expirationDate, level, doesNotExpire, allPaymentMethods,
        doNotRenew, hasActiveFreeTrial, freeTrialExpirationDate, isEligibleForFreeTrial} = data || {};

    const paymentMethod = getDefaultPaymentMethod(allPaymentMethods);
    const { last4, paymentMethodId, expDate } = paymentMethod;

    const daysUntilExpired = daysBetween(new Date(), new Date(expirationDate));
    const showCardItem = level !== levelType.NONE;
    const showPayBtn = (daysUntilExpired <= 90 || isEligibleForFreeTrial) && !hasActiveFreeTrial;
    const showManageBtn = !isEligibleForFreeTrial;

    const infoText = getDetailsText(doesNotExpire, daysUntilExpired, paymentMethodId, isEligibleForFreeTrial,
        doNotRenew, hasActiveFreeTrial, freeTrialExpirationDate);

    const onManageClick = () => {
        setPage(pages.MANAGE);
    };

    const onPayNowClick = () => {
        setPayNow(!isEligibleForFreeTrial);
        setPage(pages.PLAN_SELECT);
    };

    const onTermsClick = () => {
        openTermDetailsPage(paymentType);
    };

    const vdsSubscription = paymentType === PAYMENT_TYPE.VDS;

    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <div className={`flexColumn`}>
                    {
                        isEligibleForFreeTrial && vdsSubscription && <VdsSplashPageNewUserItem/>
                    }
                    {
                        isEligibleForFreeTrial && !vdsSubscription && <VriSplashPageNewUserItem/>
                    }
                    <GenericItem title={i18n.common.details}
                                 details={infoText}/>

                    <div className={'row'}>
                        {
                            showCardItem && paymentMethodId && (
                                <div className={'plan-payment-method-card'}>
                                    <div className={'plan-sub-title'}>
                                        Active Card:
                                    </div>
                                    <div className={'plan-sub-details'}>
                                        **** **** **** {last4}
                                    </div>
                                    <div className={'plan-sub-details'}>
                                        {i18n.payments.expires} {expDate}
                                    </div>
                                </div>
                            )
                        }
                        <div className={'col-2'}></div>
                    </div>

                    <div className={`flexSpaceBetween`}>
                        <div className={`flex margin-top-1`}>
                            <BackButton onClick={() => setRootPage(SUBSCRIPTION_ROOT_PAGES.HOME)}/>

                            {
                                showManageBtn && (
                                    <GenericButton onClick={onManageClick} text={i18n.payments.manage}/>
                                )
                            }

                            {showPayBtn
                                && <GenericButton onClick={onPayNowClick}
                                                  cssClasses={`margin-left-1`}
                                                  text={isEligibleForFreeTrial ? i18n.payments.beginFreeTrial : i18n.payments.payNow}/>}
                        </div>
                        <GenericButton onClick={onTermsClick}
                                       cssClasses={`margin-left-1 button-gray`}
                                       text={i18n.payments.terms}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SplashPage;